<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 420px;"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        @grid-ready="onGridReady"
                        />
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    props: ['modelGroup' , 'modelCd', 'modelId', 'itemId'],
    components: {Layout, AgGridVue},
    data() {
        return {
            title: 'BOM 이력',

            rowCount:0,
            file: {
                name: undefined
            },
            fileLoaded: false,

            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {},
            
            maker: '', /** 제조사 */
            makerList: [], /** 제조사 리스트*/
            modelGroupList: [], /** 제품군 리스트*/
            modelGroupNmList: [], /** 제품군 명칭 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */
            setupGroupId: '',

            columnDefs:[
                {
                    headerName: '제조사', 
                    width:200,
                    field:'makerNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '제품군', 
                    width:150,
                    field:'modelGroupNm',
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '대표모델', 
                    width:180,
                    field:'standardModelNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '모델', 
                    width:200,
                    field:'modelNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '품번',
                  width:130,
                  field:'itemCd',
                  cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '품명',
                  width:150,
                  field:'itemNm',
                  cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '규격',
                  width:200,
                  field:'itemSpec',
                  cellStyle:{textAlign:'center'}
                },
                {
                  headerName: '생산일자',
                  width:200,
                  field:'prodDt',
                  cellStyle:{textAlign:'center'},
                  valueFormatter: (params) => {
                    return this.getDateFormat(`${params.value}`)
                  }
                },
                {
                  headerName: '소요량',
                  width:130,
                  field:'itemQty',
                  cellStyle:{textAlign:'center'}
                },
              {
                headerName: '버전',
                width:130,
                field:'verId',
                cellStyle:{textAlign:'center'}
              }
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            form: {}
        }
    },
    mounted() {
      console.log(this.modelGroup);
      console.log(this.modelCd);
      console.log(this.itemId);
    },
    methods: {
        closeModal() {
            this.$parent.close();
        },
        onGridReady(){
            this.$store.commit('loading')
            this.$http
                .post("/api/bomMng/detail/popup", {
                  modelGroup: this.modelGroup,
                  modelCd: this.modelCd,
                  modelId: this.modelId,
                  itemId: this.itemId
                })
                .then(response => {
                  console.log(response.data)
                  this.rowData = response.data
                }).finally(() => {
              this.$store.commit('finish')
            });
        },
        getDateFormat(val) {
          if (val) {
            return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
          }
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>